import { MessageBar as FluentMessageBar } from "@fluentui/web-components";
/**
 * MessageBar
 * @summary A Message Bar Custom HTML Element with custom styling and behavior based on Fluent UI's MessageBar.
 *
 * @example
 * ```html
 * <fabric-message-bar
 *   shape="rounded"
 *   layout="singleline"
 *   intent="info"
 *   role="status">
 *   <span slot="icon">ℹ️</span>
 *   Important information
 *   <span slot="actions"><button>Action</button></span>
 *   <span slot="dismiss">✖</span>
 * </fabric-message-bar>
 * ```
 *
 * @attr {MessageBarShape} shape - Sets the shape of the Message Bar. Possible values are 'rounded' or 'square'.
 * @attr {MessageBarLayout} layout - Sets the layout of the control. Possible values are 'multiline' or 'singleline'.
 * @attr {MessageBarIntent} intent - Sets the intent of the control. Possible values are 'success', 'warning', 'error', or 'info'.
 *
 * @prop {MessageBarShape} shape - Sets the shape of the Message Bar. Possible values are 'rounded' or 'square'.
 * @prop {MessageBarLayout} layout - Sets the layout of the control. Possible values are 'multiline' or 'singleline'.
 * @prop {MessageBarIntent} intent - Sets the intent of the control. Possible values are 'success', 'warning', 'error', or 'info'.
 *
 * @slot icon - Slot for the icon content.
 * @slot - The default slot for the content.
 * @slot actions - Slot for the actions content.
 * @slot dismiss - Slot for the dismiss button content.
 *
 * @csspart content - The main content container of the Message Bar.
 * @csspart actions - The container for action elements.
 *
 * @method dismissMessageBar - Method to emit a `dismiss` event when the message bar is dismissed.
 *
 * @fires dismiss - Fired when the message bar is dismissed.
 *
 * @extends FluentMessageBar
 * @tagname fabric-message-bar
 * @public
 */
export class MessageBar extends FluentMessageBar {
}
//# sourceMappingURL=message-bar.js.map